import { THEME } from 'GlobalStyles';
import { hasSingleRole } from 'services/Authorization';
import strings from 'strings';
import { FeatureFlags } from 'UI/constants/featureFlags';
import { Roles } from 'UI/constants/roles';
import { hasFeatureFlag } from 'UI/utils';

export const METRICS_MAP = Object.freeze({
  Headcount: 'headcount',
  OnTrack: 'onTrack',
  AtRisk: 'atRisk',
  Behind: 'behind',
  Under3Months: 'under3Months',
  InTraining: 'inTraining'
});

export const METRICS_TITLE = Object.freeze({
  [METRICS_MAP.Headcount]: 'Recruiters Headcount',
  [METRICS_MAP.OnTrack]: 'On Track',
  [METRICS_MAP.AtRisk]: 'At Risk',
  [METRICS_MAP.Behind]: 'Behind',
  [METRICS_MAP.Under3Months]: 'Under 3 Months',
  [METRICS_MAP.InTraining]: 'In Training'
});

export const METRICS = Object.freeze({
  [METRICS_MAP.Headcount]: {
    paramName: 'headcount',
    color: THEME.palette.grey[700]
  },
  [METRICS_MAP.OnTrack]: {
    paramName: 'onTrack',
    color: THEME.palette.success.main
  },
  [METRICS_MAP.AtRisk]: {
    paramName: 'atRisk',
    color: THEME.palette.error.main
  },
  [METRICS_MAP.Behind]: {
    paramName: 'behind',
    color: THEME.palette.warning.main
  },
  [METRICS_MAP.Under3Months]: {
    paramName: 'under3Months',
    color: THEME.palette.grey[600]
  },
  [METRICS_MAP.InTraining]: {
    paramName: 'inTraining',
    color: THEME.palette.info.main
  }
});

export const SUPPORT_ACTIVITIES = [
  {
    id: 'call',
    title: strings.commandCenter.shared.supportActivities.call
  },
  {
    id: 'email',
    title: strings.commandCenter.shared.supportActivities.email
  }
];

// This is used to fill options in filter select. Will be removed when the endpoint is done.
export const COUNTRY_CODES = [
  {
    id: 'US',
    title: 'US'
  },
  {
    id: 'MX',
    title: 'MX'
  },
  {
    id: 'CA',
    title: 'CA'
  }
];

export const HEALTH_STATUS_DESCRIPTION = [
  strings.commandCenter.healthDistributionInfo.atRisk,
  strings.commandCenter.healthDistributionInfo.behind,
  strings.commandCenter.healthDistributionInfo.onTrack
];

export const TRACKING_CASH_IN_METRICS = hasFeatureFlag(FeatureFlags.CommandCenterTrackingCashIn)
  ? ['trackingCashIn']
  : [];

export const GOAL_METRICS = [
  'inMailsGoals',
  'callsGoal',
  'bulksGoal',
  'peopleReachedGoal',
  'livePostingsDailyGoal',
  'callsTimeGoal',
  'sendoutsGoal',
  'avgInMailsGoals'
];

export const OVERALL_PERFORMANCE_METRICS = [
  'avgFeeMoney',
  'avgFeePercentage',
  'avgInMails',
  'avgTodayLivePosts',
  'billings',
  'bulks',
  'calls',
  'callsTime',
  'candidatesAdded',
  'careerCashIn',
  'cashIn',
  'cashInYTD',
  'channelPartner1Name',
  'channelPartner2Name',
  'companiesAdded',
  'contactsAdded',
  'daysInStatus',
  'directorName',
  'drawBalance',
  'estimates',
  'feeAgreementsSent',
  'feeAgreementsSigned',
  'haAdded',
  'healthStatus',
  'hireDate',
  'inMails',
  'newLivePosts',
  'notSignedCompaniesJo',
  'outStandingBillings',
  'peopleReached',
  'placements',
  'posts',
  'production',
  'productionYTD',
  'recruitedBy',
  'recruiterName',
  'sendouts',
  'sendovers',
  'signedCompaniesJo',
  'team',
  'teamSupervisorsNames',
  'tenure',
  'trackingProduction',
  'countryCode',
  'location'
];

export const FEEDBACK_ACTIVITIES_METRICS = [
  'lastFeedbackActivityType',
  'lastFeedbackActivityGiverEmpNo',
  'lastFeedbackActivityGiverName',
  'lastFeedbackActivityDate'
];

export const FEEDBACK_NOTE_METRICS = !hasSingleRole(Roles.Recruiter)
  ? ['lastFeedbackNoteDate', 'lastFeedbackNoteGiverName']
  : [];

export const EMPLOYEE_STATUS_METRICS = ['employeeStatus', 'termDate'];

export const ACTIVE_METRICS = ['activeSendouts'];
